import React from 'react';

import { Button } from '@mui/material';
import PropTypes from 'prop-types';

import ChevronDown from 'components/SvgComponents/icons/ChevronDown';
import ChevronUp from 'components/SvgComponents/icons/ChevronUp';
import { CLASSIC_TYPO } from 'theme/typography';

export const SelectButton = ({ isOpen = false, children, onOpen, disabled = false }) => (
  <Button
    onClick={onOpen}
    disableElevation
    disableRipple
    disabled={disabled}
    sx={{
      height: '40px',
      width: '100%',
      display: 'inline-flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingLeft: 3,
      paddingRight: 3,
      backgroundColor: 'background.primary',
      border: '2px solid',
      borderColor: 'background.primary',
      borderRadius: '8px',
      textTransform: 'none',
      fontFamily: CLASSIC_TYPO,
      color: 'text.primary',
      transition: 'all 0.3s ease-out',
      '&.Mui-disabled': {
        color: 'text.primary',
        opacity: '0.3',
      },
      '&:hover:not(disabled)': {
        color: 'text.dark',
        backgroundColor: 'background.primary',
      },
      '&:focus:not(disabled)': {
        color: 'text.dark',
      },
      '&:active:not(disabled)': {
        color: 'text.dark',
        backgroundColor: 'background.secondary',
        border: '2px solid',
        borderColor: 'background.secondary',
      },
    }}
  >
    {children}
    {isOpen ? <ChevronUp width={16} /> : <ChevronDown width={16} />}
  </Button>
);

SelectButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  onOpen: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  disabled: PropTypes.bool,
};
